<mat-toolbar color="primary">
    <a routerLink="/auth" aria-label="LINQ sign in">
        <img [src]="IMAGE_LINQ" alt="LINQ" width="80" height="60">
    </a>
</mat-toolbar>
<main class="registered-container">
    <div class="registered-content" id="registered-message-id">
        <mat-icon class="icon" aria-hidden="true">mark_email_unread</mat-icon>
        <h1>Check your email</h1>
        @if (email) {
            <p>You've registered. We've sent an email to <strong>{{email}}</strong> with a link to activate your account. Click the link to finish setting up.</p>
        }@else {
            <p>You've registered. We've sent you an email with a link to activate your account. Click the link to finish setting up.</p>
        }

        <h2>Didn't get the email?</h2>
        <ul>
            <li>It can take a few minutes to arrive, and it may be in your junk or spam folder.</li>
            <li>The link only works for a limited time. If it has expired, <a routerLink="/auth">sign in</a> with your email and password and we'll send a new one.</li>
        </ul>

        <p class="device" [class.small]="app.smallScreen">
            <mat-icon aria-hidden="true">laptop</mat-icon>
            <span><strong>Use a laptop or computer.</strong> LINQ models can't be created on a phone or touchscreen, so switch to a computer before you open the link.</span>
        </p>

        <a mat-flat-button color="accent" routerLink="/auth" class="sign-in">Go to sign in</a>
    </div>
</main>
